import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import Tile from 'ol/layer/Tile';
import Vector from 'ol/layer/Vector';
import Zoom from 'ol/control/Zoom';
import TileWMS from 'ol/source/TileWMS';
import {fromLonLat} from 'ol/proj';
import BingMaps from 'ol/source/BingMaps';
import OSM from 'ol/source/OSM';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Geolocation from 'ol/Geolocation';
import Feature from 'ol/Feature';
import Style from 'ol/style/Style';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Point from 'ol/geom/Point';
import $ from 'jQuery';
import {defaults} from 'ol/interaction';

global.baseLayersArray = [];
global.topLayersArray = [];
global.baseLayersArrayLength;
global.topLayersArrayLength;
//var baseLayersArray = [];
//var topLayersArray = [];
//var baseLayersArrayLength;
//var topLayersArrayLength;

//var key = 'Ah4C9Ite0bCpmz4Iu0MExgvuIfjpvEiQt06FTP_qBXjFptMM5WA9wPVp_WZfzfOr';
var extent = [1781111.8,8859142.8, 2003750.8,9349764.1];
var geoserverUrl = 'https://karta.sundsvall.se/geoserver/wms';
var geoserverUrl_test = 'https://kartatest.sundsvall.se/geoserver/wms';

//var roads = new TileLayer({
  //source: new BingMaps({key: key, imagerySet: 'RoadOnDemand'})
//});

var osm = new TileLayer({
  source: new OSM({attributions: '&copy; OpenStreetMap contributors'})
});

var ol_osm = new TileLayer({
  source: new OSM({attributions: '&copy; OpenStreetMap contributors'})
});

var topo = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:topowebbkartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_topo = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:topowebbkartan', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto1960 = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '1960 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:HistoriskaOrtofoton1960_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto1960 = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '1960 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:HistoriskaOrtofoton1960_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto1975 = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '1975 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:HistoriskaOrtofoton1975_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto1975 = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '1975 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:HistoriskaOrtofoton1975_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2007 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2007 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2007_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2007 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2007 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2007_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2010 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2010 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2010_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2010 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2010 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2010_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2013 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2013 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2013_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2013 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2013 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2013_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2015 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2015 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2015_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2015 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2015 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2015_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2017 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2017 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2017_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2017 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2017 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2017_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2019 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2019 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2019_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2019 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2019 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2019_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2021 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2021 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2021_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2021 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2021 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2021_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2023 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2023 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2023_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2023 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2023 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2023_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var lmorto = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2023 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:Ortofoto50_25cm', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_lmorto = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2019 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:Ortofoto50_25cm', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var lutning = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:terranglutning', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_lutning = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:terranglutning', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var skugg = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:terrangskuggning_wms', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_skugg = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet Geodatasamverkan',
  	url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:terrangskuggning_wms', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var friluft = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Friluftskarta', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_friluft = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Friluftskarta', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var detalj = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: {'LAYERS': 'SundsvallsKommun:detaljplan_mosaik', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_detalj = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: {'LAYERS': 'SundsvallsKommun:detaljplan_mosaik', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var hist1642 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1642', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1642 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1642', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1857 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1857', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1857 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1857', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1878 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1878', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1878 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1878', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1910 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1910', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1910 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1910', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1917 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl_test,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1917', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1917 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl_test,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1917', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1935 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1935', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1935 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1935', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1939 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1939', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1939 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1939', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1952 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1952', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1952 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1952', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ekonomiska = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:EkonomiskaKartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_ekonomiska = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:EkonomiskaKartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var general = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Generalstabskartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_general = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Generalstabskartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var laga = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:LagaSkifteskartor_mosaik', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_laga = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:LagaSkifteskartor_mosaik', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var orientering = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Njurunda OK',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:OrienteringNjurunda', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3006',
	  transition: 0
  })
});

var ol_orientering = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Njurunda OK',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:OrienteringNjurunda', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3006',
	  transition: 0
  })
});

baseLayersArray.push(topo);
baseLayersArray.push(friluft);
baseLayersArray.push(osm);
baseLayersArray.push(orto1960);
baseLayersArray.push(orto1975);
baseLayersArray.push(orto2007);
baseLayersArray.push(orto2010);
baseLayersArray.push(orto2013);
baseLayersArray.push(orto2015);
baseLayersArray.push(orto2017);
baseLayersArray.push(orto2019);
baseLayersArray.push(orto2021);
baseLayersArray.push(orto2023);
baseLayersArray.push(lmorto);
baseLayersArray.push(lutning);
baseLayersArray.push(skugg);
baseLayersArray.push(detalj);
baseLayersArray.push(hist1642);
baseLayersArray.push(hist1857);
baseLayersArray.push(hist1878);
baseLayersArray.push(hist1910);
baseLayersArray.push(hist1917);
baseLayersArray.push(hist1935);
baseLayersArray.push(hist1939);
baseLayersArray.push(hist1952);
baseLayersArray.push(ekonomiska);
baseLayersArray.push(general);
baseLayersArray.push(laga);
//baseLayersArray.push(orientering);

topLayersArray.push(ol_topo);
topLayersArray.push(ol_friluft);
topLayersArray.push(ol_osm);
topLayersArray.push(ol_orto1960);
topLayersArray.push(ol_orto1975);
topLayersArray.push(ol_orto2007);
topLayersArray.push(ol_orto2010);
topLayersArray.push(ol_orto2013);
topLayersArray.push(ol_orto2015);
topLayersArray.push(ol_orto2017);
topLayersArray.push(ol_orto2019);
topLayersArray.push(ol_orto2021);
topLayersArray.push(ol_orto2023);
topLayersArray.push(ol_lmorto);
topLayersArray.push(ol_lutning);
topLayersArray.push(ol_skugg);
topLayersArray.push(ol_detalj);
topLayersArray.push(ol_hist1642);
topLayersArray.push(ol_hist1857);
topLayersArray.push(ol_hist1878);
topLayersArray.push(ol_hist1910);
topLayersArray.push(ol_hist1917);
topLayersArray.push(ol_hist1935);
topLayersArray.push(ol_hist1939);
topLayersArray.push(ol_hist1952);
topLayersArray.push(ol_ekonomiska);
topLayersArray.push(ol_general);
topLayersArray.push(ol_laga);
//topLayersArray.push(ol_orientering);

//var imagery = new Tile({
  //source: new BingMaps({key: key, imagerySet: 'Aerial'})
//});

var container = document.getElementById('map');

var view = new View({
  center: fromLonLat([17.3, 62.4]),
  extent: extent,
  zoom: 13
});

var map = new Map({
  layers: baseLayersArray.concat(topLayersArray),
//  layers: [orto1960, ol_lmorto],
  target: 'map',
  loadTilesWhileAnimating: true,
  loadTilesWhileInteracting: true,
  view: view
});

var swipe = document.getElementById('swipe');

el('select1').addEventListener('change', function() {
  var lager = document.getElementById('select1').value;
  // Zoom in if needed if the layer is 'Skannade detaljplaner'
  if (lager === '16' && map.getView().getZoom() < 15) {
    map.getView().setZoom(16);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1642'
  if (lager === '17' && map.getView().getZoom() < 16) {
    map.getView().setZoom(16);
    map.getView().setCenter([1929279, 8952216]);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1642'
  if (lager === '18' && map.getView().getZoom() < 16) {
    map.getView().setZoom(16);
    map.getView().setCenter([1929279, 8952216]);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1917'
  if (lager === '21' && map.getView().getZoom() < 16) {
    map.getView().setZoom(15);
    map.getView().setCenter([1929279, 8952216]);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1939'
  if (lager === '23' && map.getView().getZoom() < 16) {
    map.getView().setZoom(15);
    map.getView().setCenter([1930279, 8952216]);
  }
  // Zoom in if needed if the layer is 'EkonomiskaKartan'
  if (lager === '25' && map.getView().getZoom() < 13) {
    map.getView().setZoom(14);
  }
  // Zoom in if needed if the layer is 'Generalstabskartan'
  if (lager === '26' && map.getView().getZoom() < 10) {
    map.getView().setZoom(11);
  }
  // Zoom in if needed and change center if the layer is 'Laga skifte'
  if (lager === '27' && map.getView().getZoom() < 16) {
    map.getView().setZoom(15);
    map.getView().setCenter([1917881,8958816]);
  }
}, false);
el('select2').addEventListener('change', function() {
  var lager = document.getElementById('select2').value;
  // Zoom in if needed if the layer is 'Skannade detaljplaner'
  if (lager === '16' && map.getView().getZoom() < 15) {
    map.getView().setZoom(16);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1642'
  if (lager === '17' && map.getView().getZoom() < 16) {
    map.getView().setZoom(16);
    map.getView().setCenter([1927279, 8952216]);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1642'
  if (lager === '18' && map.getView().getZoom() < 16) {
    map.getView().setZoom(16);
    map.getView().setCenter([1926279, 8952216]);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1917'
  if (lager === '21' && map.getView().getZoom() < 16) {
    map.getView().setZoom(15);
    map.getView().setCenter([1930279, 8952216]);
  }
  // Zoom in if needed and change center if the layer is 'HistoriskKarta1939'
  if (lager === '23' && map.getView().getZoom() < 16) {
    map.getView().setZoom(15);
    map.getView().setCenter([1930279, 8952216]);
  }
  // Zoom in if needed if the layer is 'EkonomiskaKartan'
  if (lager === '25' && map.getView().getZoom() < 13) {
    map.getView().setZoom(14);
  }
  // Zoom in if needed if the layer is 'Generalstabskartan'
  if (lager === '26' && map.getView().getZoom() < 10) {
    map.getView().setZoom(11);
  }
  // Zoom in if needed and change center if the layer is 'Laga skifte'
  if (lager === '27' && map.getView().getZoom() < 16) {
    map.getView().setZoom(15);
    map.getView().setCenter([1917881,8958816]);
  }
}, false);

var geolocation = new Geolocation({
  // enableHighAccuracy must be set to true to have the heading value.
  trackingOptions: {
    enableHighAccuracy: true
  },
  projection: view.getProjection()
});

function el(id) {
  return document.getElementById(id);
}

el('track').addEventListener('click', function() {
  geolocation.setTracking(true);
});

//swipe.addEventListener("change", function() {
  //map.render();
//}, false);

swipe.addEventListener('input', function() {
  map.render();
}, false);

global.baseLayersArrayLength = baseLayersArray.length;

for (var i = 0; i < baseLayersArrayLength; i++) {
    baseLayersArray[i].setVisible(false);
}

global.topLayersArrayLength = topLayersArray.length;

for (var i = 0; i < topLayersArrayLength; i++) {
	topLayersArray[i].setVisible(false);

topLayersArray[i].on('prerender', function(event) {
	var ctx = event.context;
	var width = ctx.canvas.width * (swipe.value / 100);
	ctx.save();
	ctx.beginPath();
	ctx.rect(width, 0, ctx.canvas.width - width, ctx.canvas.height);
	ctx.clip();
});

topLayersArray[i].on('postrender', function(event) {
	var ctx = event.context;
	ctx.restore();
});
}

orto1960.setVisible(true);
ol_lmorto.setVisible(true);

var geolocation = new Geolocation({
	projection: view.getProjection()
});

geolocation.setTracking(true);

var positionFeature = new Feature();

positionFeature.setStyle(new Style({
	image: new Circle({
		radius: 6,
			fill: new Fill({
			color: '#3399CC'
		}),
			stroke: new Stroke({
			color: '#fff',
			width: 2
		})
	})
}));

geolocation.on('change:position', function() {
	var coordinates = geolocation.getPosition();
	positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
  view.setCenter(coordinates);
  geolocation.setTracking(false);
});

new Vector({
	map: map,
	source: new VectorSource({
		features: [positionFeature]
	})
});

function layerswitch(evt){
	baseLayersArray[evt.value].setVisible(evt.checked);
}
